import { createReducer, on } from '@ngrx/store';
import { CommandContentApiActions } from './command-content.actions';
import { adapter, initialState } from './command-content.state';

export const commandContentFeatureKey = 'command-content';

export const commandContentReducer = createReducer(
  initialState,
  on(CommandContentApiActions.commandContentLoaded, (state, { commandContent }) =>
    adapter.upsertOne(commandContent, state)
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectCommandContentIds = selectIds;
export const selectCommandContentEntities = selectEntities;
export const selectAllCommandContent = selectAll;
